
const issueDateFilterParams = {
    buttons: ['clear'],
    suppressAndOrCondition: true,
    comparator: function(selectedDateMidnight, value) {
        let d = TELSA.moment(selectedDateMidnight);
        let v = TELSA.moment(value);
        if(v < d) {
            return -1;
        }
        else if(v > d) {
            return 1;
        }
        else {
            return 0;
        }
    }
};



export { issueDateFilterParams };
